import { appFetch, AppFetchResponse } from "../utils/appFetch";
import {FilterProps} from "../components/table/tableTypes";

export const getDailyReport = async (selectedDomain: string, filters: FilterProps[]): Promise<AppFetchResponse> => {
    const { from, to } = filters.find(filter => filter.filterKey === 'days')!;
    const { options, selected } = filters.find(filter => filter.filterKey === 'templates')!;
    const templateIds = options?.filter(option => selected ? option?.key === selected : option?.key).map(option => option?.key);
    return appFetch({
        endpoint: `reports/revenue?domain=${selectedDomain}&from=${from}&to=${to}&templates=${templateIds}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}